/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export default class BookDetails extends Component {
    static get propTypes() {
        return {
            router: PropTypes.object
        };
    }
    constructor(props) {
        super(props);
        this.state = {
            activeTitle: 'Book Details'
        };
    }
    render() {
        const { pageRoutes } = this.props;
        const activePath = this.props.router.location.pathname;
        return (
            <div className="book-details-navigation-panel">
                <ul>
                    {pageRoutes.map(route => (<li key={route.path}><Link className={activePath === route.path ? 'active' : ''} to={route.path}>{route.title}</Link></li>))}
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookContainerComponents/BookNavigationPanel.js